<template>
    <v-select 
       :value="selected_parc" 
       v-bind:items="parcs"
       prepend-icon="mdi-filter-outline" 
       item-value="parkcode" 
       item-text="parkname" 
       label="Select parc"
       dense class="pl-3 pt-1" clearable
       @change="getSelection">
    </v-select>
</template>

<script>
export default {
    props: {
        selected_parc: String
    },
    data() {
        return {
            parcs: [],
        }
    },
    created() {
        this.getParcInfo();
    },
    methods: {
        getParcInfo() {
            this.$axios
                .post("ares/json/ares/task/pp/getParkInfov2.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getParcInfo"
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        this.showDialog('error', 'Error', res.data.error.message);
                    } else {
                        this.parcs = res.data.getParcInfo.info;
                    }
                })
        },
        getSelection(v){
            this.$emit('getSelection', v === null ? '' : v)
        }
    }
}

</script>
